export default "__VITE_ASSET__0116299d__"